import { apiGet } from "./client";
import type { SelectItem } from "@/types/manual.types";

export const getRegions = (): Promise<SelectItem[]> =>
  apiGet<SelectItem[]>("/Manual/GetRegionAsSelectList");

export const getDistricts = (regionId: number): Promise<SelectItem[]> =>
  apiGet<SelectItem[]>(`/Manual/GetDistrictAsSelectList?Id=${regionId}`);

export const getMfys = (districtId: number): Promise<SelectItem[]> =>
  apiGet<SelectItem[]>(`/Manual/GetMfysAsSelectList?Id=${districtId}`);

export const getSickCategories = (): Promise<SelectItem[]> =>
  apiGet<SelectItem[]>("/Manual/SickCategorySelectList");

export const getTypeHelps = (): Promise<SelectItem[]> =>
  apiGet<SelectItem[]>("/Manual/TypeHelpSelectList");

export const getSubmitterTypes = (): Promise<SelectItem[]> =>
  apiGet<SelectItem[]>("/Manual/GetApplicationSubmitterTypeSelectList");
